/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ when: NonNullable<unknown> }} Progress_Hero_SingleInputs */

const en_us2_progress_hero_single = /** @type {(inputs: Progress_Hero_SingleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`First estimate ${i?.when}`)
};

const pt_br2_progress_hero_single = /** @type {(inputs: Progress_Hero_SingleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Primeira estimativa ${i?.when}`)
};

const es_419_progress_hero_single = /** @type {(inputs: Progress_Hero_SingleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Primera estimación ${i?.when}`)
};

const pt_pt2_progress_hero_single = /** @type {(inputs: Progress_Hero_SingleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Primeira estimativa ${i?.when}`)
};

const fr_fr2_progress_hero_single = /** @type {(inputs: Progress_Hero_SingleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Première estimation ${i?.when}`)
};

const de_de2_progress_hero_single = /** @type {(inputs: Progress_Hero_SingleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Erste Schätzung ${i?.when}`)
};

const it_it2_progress_hero_single = /** @type {(inputs: Progress_Hero_SingleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Prima stima ${i?.when}`)
};

/**
* | output |
* | --- |
* | "First estimate {when}" |
*
* @param {Progress_Hero_SingleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_hero_single = /** @type {((inputs: Progress_Hero_SingleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Hero_SingleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_hero_single(inputs)
	if (locale === "es-419") return es_419_progress_hero_single(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_hero_single(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_hero_single(inputs)
	if (locale === "de-DE") return de_de2_progress_hero_single(inputs)
	if (locale === "it-IT") return it_it2_progress_hero_single(inputs)
	return en_us2_progress_hero_single(inputs)
});
export { progress_hero_single as "progress.hero_single" }